export default {"src":"/_next/static/media/email_icon.fe29114d.svg","height":29,"width":20,"blurWidth":0,"blurHeight":0};